import { useState } from "react";
import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import Pagination from "@/components/feature/Pagination";
import { newsList } from "@/mocks/news";
import usePageMeta from "@/hooks/usePageMeta";

const PAGE_SIZE = 5;

export default function NewsPage() {
  usePageMeta(
    "影视资讯 - 日韩黄色电影平台",
    "日韩黄色电影影视资讯频道：片单前瞻、行业观察、幕后故事与修复重映动态，按发布时间倒序整理日韩情色影视相关内容。",
    "影视资讯,日韩黄色电影,日韩情色电影,片单推荐,行业观察",
  );

  const [page, setPage] = useState(1);
  const sorted = [...newsList].sort((a, b) => b.date.localeCompare(a.date));
  const totalPages = Math.max(1, Math.ceil(sorted.length / PAGE_SIZE));
  const paged = sorted.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  return (
    <SiteLayout>
      <div className="w-full px-4 md:px-6 pt-8 md:pt-12 pb-16 md:pb-24 bg-background-50">
        <div className="w-full max-w-[1200px] mx-auto">
          <nav className="flex items-center gap-1.5 text-[11px] md:text-xs text-foreground-500">
            <Link to="/" className="hover:text-accent-500 transition-colors cursor-pointer">
              首页
            </Link>
            <i className="ri-arrow-right-s-line" />
            <span className="text-accent-500">影视资讯</span>
          </nav>

          <div className="mt-5 flex flex-col lg:flex-row lg:items-end justify-between gap-4">
            <div>
              <h1 className="font-heading text-2xl md:text-4xl text-foreground-950">影视资讯</h1>
              <p className="mt-3 max-w-[640px] text-xs md:text-sm leading-relaxed text-foreground-500">
                片单前瞻、行业观察、幕后故事与修复重映动态。我们只做信息整理与背景介绍，
                所有内容按发布时间倒序排列。
              </p>
            </div>
            <div className="flex items-center gap-2 text-xs text-foreground-500 shrink-0">
              <i className="ri-calendar-line" />
              共 {sorted.length} 篇 · 持续更新
            </div>
          </div>

          <div className="mt-8 flex flex-col gap-4">
            {paged.map((item) => (
              <article
                key={item.id}
                className="group rounded-lg border border-background-300/60 bg-background-100 overflow-hidden hover:border-primary-500/60 transition-colors"
              >
                <Link
                  to={`/news/detail/${item.id}`}
                  className="flex flex-col sm:flex-row cursor-pointer"
                >
                  <div className="relative w-full sm:w-[260px] lg:w-[300px] shrink-0 aspect-[16/9] sm:aspect-auto sm:h-full min-h-[160px] overflow-hidden bg-background-200">
                    <img
                      src={item.cover}
                      alt={`${item.title} 配图`}
                      title={`${item.title} - 日韩黄色电影资讯`}
                      className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                    />
                  </div>
                  <div className="flex-1 min-w-0 p-4 md:p-6">
                    <div className="flex flex-wrap items-center gap-2 text-[11px]">
                      <span className="px-2 py-0.5 rounded-md bg-accent-500/10 text-accent-500">
                        {item.category}
                      </span>
                      <span className="text-foreground-400">{item.date}</span>
                    </div>
                    <h2 className="mt-2.5 font-heading text-lg md:text-xl leading-snug text-foreground-900 group-hover:text-accent-500 transition-colors">
                      {item.title}
                    </h2>
                    <p className="mt-2 text-xs md:text-sm leading-relaxed text-foreground-500 line-clamp-2">
                      {item.summary}
                    </p>
                    <span className="mt-3 inline-flex items-center gap-1.5 text-[11px] text-foreground-500 group-hover:text-accent-500 transition-colors">
                      阅读全文
                      <i className="ri-arrow-right-line" />
                    </span>
                  </div>
                </Link>
              </article>
            ))}
          </div>

          {sorted.length === 0 && (
            <div className="mt-8 rounded-lg border border-background-300/60 bg-background-100 px-6 py-16 text-center">
              <h2 className="text-base text-foreground-900">暂无资讯内容</h2>
              <p className="mt-2 text-xs text-foreground-500">内容正在整理中，请稍后再来。</p>
            </div>
          )}

          <Pagination page={page} totalPages={totalPages} onChange={setPage} />
        </div>
      </div>
    </SiteLayout>
  );
}